<template>
    <div id="invoice_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span id="invoiceHeader" class="page-title">Post Finance Charge</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackInvoiceList"  >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content post-finance-charge">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="financeInvoiceForm">
                                <div class="form-row row-cols-md-3 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require">Invoice Due Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="invoice_date" name="invoice_date" v-model="invoice_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="invoice_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{invoice_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Payment Cut-Off</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="payment_cutoff" name="payment_cutoff" v-model="payment_cutoff" :config="optionsDueDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="payment_cutoff" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{payment_cutoff_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Charge Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="charge_date" name="charge_date" v-model="charge_date" :config="optionsDueDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="charge_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{charge_date_error_msg}}</div>
                                    </div>
                                    <div class="form-group">
                                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                        </div>
                                    </div>    
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateFinanceInvoiceBtn" class="btn btn-primary" v-on:click.prevent="PostFinanceInvoice()" >
                                    <i class="fp-save"> </i>  POST
                                    </button>
                                    <button type="submit" id="CancelFinanceInvoiceBtn" class="btn btn-tertiary" v-on:click.prevent="BackInvoiceList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>        
                </div>    
            </template>    
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>        
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';
export default {
    name:"FinanceInvoiceCreate",
    metaInfo() {
        return {
            title: "Create Finance Invoice | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        optionsDueDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        invoice_date:null,
        payment_cutoff:"",
        charge_date:"",
        invoice_date_error_msg:"",
        payment_cutoff_error_msg:"",
        charge_date_error_msg:"",
    }),
    watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_invoice') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        
        var path = window.location.pathname;
        var segments = path.split("/");
       
        var todayDate = self.getTodayDate();
        self.optionsDate.maxDate = moment(todayDate,"MM/DD/YYYY");
        // self.optionsDueDate.minDate = moment(todayDate,"MM/DD/YYYY");
    },
    methods: {
        BackInvoiceList() {
            var self = this;
            self.$router.push("/invoice/list");
        },
        PostFinanceInvoice() {
            var self = this;
            var error = false;
            self.invoice_date_error_msg = "";
            self.payment_cutoff_error_msg = "";
            self.charge_date_error_msg = "";

            if (!self.invoice_date || self.invoice_date == null || self.invoice_date == "") {
                self.invoice_date_error_msg = "Invoice Date Required.";
                error = true;
            }

            if (!self.payment_cutoff || self.payment_cutoff == null || self.payment_cutoff == "") {
                self.payment_cutoff_error_msg = "Payment Cut Off Required.";
                error = true;
            }

            if (!self.charge_date || self.charge_date == null || self.charge_date == "") {
                self.charge_date_error_msg = "Charge Date Required.";
                error = true;
            }

            if (!error) {
                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");

                var fields = $("#financeInvoiceForm").serializeArray();

                if (segments[4])
                {
                    $("#CreateFinanceInvoiceBtn").val("Updating ...");
                    $("#CreateFinanceInvoiceBtn").prop("disabled", true);
                    $("#CancelFinanceInvoiceBtn").prop("disabled",true);

                } else {

                    $("#CreateFinanceInvoiceBtn").val("Saving ...");
                    $("#CreateFinanceInvoiceBtn").prop("disabled", true);
                    $("#CancelFinanceInvoiceBtn").prop("disabled",true);
                }

                $.ajax({
                    url: process.env.ROOT_API + "/invoice/finance/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        if (segments[4])
                        {
                            $("#CreateFinanceInvoiceBtn").val("Update");
                            $("#CreateFinanceInvoiceBtn").prop("disabled", false);
                            $("#CancelFinanceInvoiceBtn").prop("disabled",false);
                        } else {

                            $("#CreateFinanceInvoiceBtn").val("Save");
                            $("#CreateFinanceInvoiceBtn").prop("disabled", false);
                            $("#CancelFinanceInvoiceBtn").prop("disabled",false);

                        }                        
                        
                        if (data.status == "success") {
                            var batchId = data.batch_id;
                            var batchNum1 = data.batch;
                            self.$router.push("/invoice/list?from=fin_post&&batch_id="+batchId+"&&num="+batchNum1);

                        } else {

                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[4])
                        {
                            $("#CreateFinanceInvoiceBtn").val("Update");
                            $("#CreateFinanceInvoiceBtn").prop("disabled", false);
                            $("#CancelFinanceInvoiceBtn").prop("disabled",false);
                        } else {
                           
                            $("#CreateFinanceInvoiceBtn").val("Save");
                            $("#CreateFinanceInvoiceBtn").prop("disabled", false);
                            $("#CancelFinanceInvoiceBtn").prop("disabled",false);

                        }
                        self.generateStatusCodeMessage(jqXHR,false,'permit-invoice-create');
                    }
                });

            }


        },
    }
}
</script>
<style scoped>
.permit-amount {
	font-weight: normal;
	font-size: 12px;
	color: #787878;
	float: left;
	width: 100%;
	/* text-align: left; */
	margin-bottom: 0;
}
</style>





// WEBPACK FOOTER //
// src/components/invoice/PostFinanceChargeInvoice.vue